/* Belterbox — scroll reveal (progressive enhancement) */
(function () {
  var root = document.documentElement;
  root.classList.add('bb-js');

  function revealAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  function init() {
    var els = document.querySelectorAll('.bb-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(els); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
    // safety: reveal anything still hidden after 2.5s (e.g. observer edge cases)
    setTimeout(function () { revealAll(document.querySelectorAll('.bb-reveal:not(.is-in)')); }, 2500);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Belterbox — quick add to cart (progressive enhancement)
   Any link with data-bb-add="<variant id>[,<variant id>…]" adds those variants ON TOP of the
   current cart. Never use /cart/<id>:1 permalinks for shop buttons: they wipe the cart and jump
   straight to checkout, so nobody could buy two products (customer report, 2026-09-16).
   - digital goods: variants already in the cart are skipped, never bumped to qty 2
   - data-bb-add-go="cart"      → open the cart afterwards (combos); default = stay + toast
   - data-bb-add-discount="CODE" → apply the code before opening the cart
   Without JS (or on any error) the href is a plain GET /cart/add, which also adds, never replaces. */
(function () {
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var cartJs = cartUrl + '.js';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toast, toastTimer;

  function json(res) { if (!res.ok) throw new Error(res.status); return res.json(); }

  function setCount(n) {
    var els = document.querySelectorAll('[data-bb-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].classList.toggle('is-empty', n === 0);
    }
  }

  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bb-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="bb-toast__msg"></span>' +
        '<span class="bb-toast__acts">' +
        '<button type="button" class="bb-toast__btn bb-toast__btn--ghost" data-bb-toast-close>keep shopping</button>' +
        '<a class="bb-toast__btn bb-toast__btn--go" href="' + cartUrl + '">view cart &rarr;</a>' +
        '</span>';
      toast.querySelector('[data-bb-toast-close]').addEventListener('click', hideToast);
      document.body.appendChild(toast);
    }
    toast.querySelector('.bb-toast__msg').textContent = msg;
    toast.offsetWidth; // restart the enter transition
    toast.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }
  function hideToast() { if (toast) toast.classList.remove('is-in'); }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-bb-add]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    var ids = a.getAttribute('data-bb-add').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    if (!ids.length || !window.fetch) return;
    e.preventDefault();

    var goCart = a.getAttribute('data-bb-add-go') === 'cart';
    var code = a.getAttribute('data-bb-add-discount');
    var name = (a.closest('article') && a.closest('article').querySelector('[class$="__name"]')) || null;
    a.setAttribute('aria-busy', 'true');

    fetch(cartJs, { credentials: 'same-origin' })
      .then(json)
      .then(function (cart) {
        var have = cart.items.map(function (it) { return it.variant_id; });
        var todo = ids.filter(function (id) { return have.indexOf(id) === -1; });
        if (!todo.length) return { cart: cart, added: 0 };
        return fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: todo.map(function (id) { return { id: id, quantity: 1 }; }) })
        }).then(json).then(function () {
          return fetch(cartJs, { credentials: 'same-origin' }).then(json);
        }).then(function (c) { return { cart: c, added: todo.length }; });
      })
      .then(function (r) {
        if (code) {
          return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
            .catch(function () {}).then(function () { return r; });
        }
        return r;
      })
      .then(function (r) {
        if (goCart) { window.location.href = cartUrl; return; }
        a.removeAttribute('aria-busy');
        setCount(r.cart.item_count);
        var label = name ? name.textContent.trim() : 'it';
        showToast(r.added ? label + ' is in your cart' : label + ' is already in your cart');
        document.dispatchEvent(new CustomEvent('bb:cart:added', { detail: { ids: ids, cart: r.cart } }));
      })
      .catch(function () {
        // anything odd (sold out, network, app interference): fall back to the plain add link
        window.location.href = a.href;
      });
  });
})();
